module.exports = __webpack_public_path__ + "img/1479939064.56f493e8.jpg";